import { render, staticRenderFns } from "./LayoutMobile.vue?vue&type=template&id=532ba702&scoped=true&"
import script from "./LayoutMobile.vue?vue&type=script&lang=js&"
export * from "./LayoutMobile.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMobile.vue?vue&type=style&index=0&id=532ba702&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ba702",
  null
  
)

export default component.exports